<script lang="ts" setup>
import DirectSalesForm from '@/domains/direct-sales/components/direct-sales-form/direct-sales-form.vue'
import { EUiFormColor } from '@/domains/direct-sales/const/form.const'
import { DIRECT_SALES_UTMS } from '@/domains/direct-sales/const/utm.const'

import { useRoute } from 'vue-router'
import UiSeparator from '@/components/UiSeparator/UiSeparator.vue'

import WellbeingSaleHero from '@/domains/wellbeing-sale/wellbeing-sale--hero/wellbeing-sale--hero.vue'
import WellbeingSaleWellness from '@/domains/wellbeing-sale/wellbeing-sale--wellness/wellbeing-sale--wellness.vue'
import WellbeingSalePossibilities from '@/domains/wellbeing-sale/wellbeing-sale--possibilities/wellbeing-sale--possibilities.vue'
import WellbeingSaleForEmploy from '@/domains/wellbeing-sale/wellbeing-sale--forEmploy/wellbeing-sale--forEmploy.vue'
import WellbeingSaleAssistant from '@/domains/wellbeing-sale/wellbeing-sale--assistant/wellbeing-sale--assistant.vue'
import WellbeingSaleReporting from '@/domains/wellbeing-sale/wellbeing-sale--reporting/wellbeing-sale--reporting.vue'
import WellbeingSaleForWorkers from '@/domains/wellbeing-sale/wellbeing-sale--forWorkers/wellbeing-sale--forWorkers.vue'
import WellbeingSaleCommandCenter from '@/domains/wellbeing-sale/wellbeing-sale--command/wellbeing-sale--command.vue'
import WellbeingSaleForEmployers from '@/domains/wellbeing-sale/wellbeing-sale--forEmployers/wellbeing-sale--forEmployers.vue'
import WellbeingSaleDashboard from '@/domains/wellbeing-sale/wellbeing-sale--dashboard/wellbeing-sale--dashboard.vue'

const { locale, t } = useI18n()
const HOOK = '#formularz'

const route = useRoute()

onMounted(() => {
  if (route.hash) {
    const element = document.querySelector(route.hash)
    if (element) {
      window.setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' })
      }, 3000)
    }
  }
})

useHead({
  title: t('pageTitles.wellbeingSale.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.wellbeingSale.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.wellbeingSale.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.wellbeingSale.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.wellbeingSale.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.wellbeingSale.canonical.pl'),
    },
  ],
})
</script>

<template>
  <div>
    <WellbeingSaleHero
      type = "primary"
      desktop-image="/images/hero/wbs_d.webp"
      mobile-image="/images/hero/wbs_m.webp"
      :header="$t('wellbeingSale.hero.title')"
      :text="$t('wellbeingSale.hero.subtitle')"
      :cloud-text="$t('wellbeingSale.hero.cloud')"
      :button="{
        text: $t('wellbeingSale.hero.button'),
        to: HOOK,
      }"
    />

    <UiSeparator />

    <WellbeingSaleWellness />

    <WellbeingSalePossibilities
      :hook-to="HOOK"
    />
    
    <WellbeingSaleForEmploy />

    <UiSeparator />

    <ClientOnly>
      <WellbeingSaleForEmployers
        :hook-to="HOOK"
      />
    </ClientOnly>

    <WellbeingSaleDashboard
      :hook-to="HOOK"
    />
    
    <WellbeingSaleAssistant
      :hook-to="HOOK"
    />

    <WellbeingSaleForWorkers />

    <WellbeingSaleCommandCenter />

    <WellbeingSaleReporting />

    <DirectSalesForm
      :header="$t('home.form.header')"
      :color="EUiFormColor.GRAY"
      :utm="DIRECT_SALES_UTMS.products.wellbeingSalePage"
      :badge="`/icons/badges/flag-4_${locale}.png`"
      :form-id="$t('home.form.id')"
    />
  </div>
</template>
